export default __webpack_public_path__ + "media/images/images_v2/logotop-3dd77a5bb842f35bdac5052a52126fbf.png";